import { Route, Routes, useLocation, useParams } from "react-router-dom";
import ThemedApp from "./ThemedApp";
import ForgotPassword from "./components/auth/forgotPassword/ForgotPassword";
import Login from "./components/auth/login/Login";
import RecoverPassword from "./components/auth/recoverPassword/RecoverPassword";
import DashBoardLayout from "./components/layout";
import PageNotFound from "./components/shared/emptyState/PageNotFound";
import useFetchThemeConfig from "./hooks/useFetchThemeConfig";
import useUpdateDocumentElements from "./useUpdateDocumentElements";

import { Home } from "./pages/homePage/Home";
import { VendorUser } from "./pages/vendorUser/VendorUser";
import { VendorBenefits } from "./pages/vendorBenefits/VendorBenefits";
import { Benefits } from "./pages/benefits/Benefits";
import PrivateRoute from "./components/auth/privateRoutes/PrivateRoute";
import PublicRoute from "./components/auth/publicRoutes/PublicRoute";

const AppRoutes = () => {
  const { slug } = useParams<{ slug: string }>();
  const location = useLocation();

  const { themeConfig, loading, error } = useFetchThemeConfig(slug);

  useUpdateDocumentElements(themeConfig);

  if (loading) return <div>Loading...</div>;
  if (error)
    return (
      <div>
        <PageNotFound />
      </div>
    );

  const defaultThemeConfig = {
    color: "#FFFFFF",
    name: "Default Name",
    favicon_img: "",
    logo_img: "",
    title: "Default Title",
  };

  return (
    <ThemedApp themeConfig={themeConfig || defaultThemeConfig}>
      <Routes>
        <Route
          path="login"
          element={
            <PublicRoute>
              <Login themeConfig={themeConfig || defaultThemeConfig} />
            </PublicRoute>
          }
        />
        <Route
          path="forgot-password"
          element={
            <ForgotPassword themeConfig={themeConfig || defaultThemeConfig} />
          }
        />
        <Route
          path="reset-password"
          element={
            <RecoverPassword themeConfig={themeConfig || defaultThemeConfig} />
          }
        />
        <Route
          path="vendors/*"
          element={
            <DashBoardLayout
              logo={themeConfig?.logo_img || defaultThemeConfig.logo_img}
            >
              <Routes>
                <Route
                  path=""
                  element={
                    <PrivateRoute roles={["admin"]}>
                      <Home themeConfig={themeConfig || defaultThemeConfig} />
                    </PrivateRoute>
                  }
                />{" "}
              </Routes>
            </DashBoardLayout>
          }
        />
        <Route
          path=":id/users"
          element={
            <DashBoardLayout
              logo={themeConfig?.logo_img || defaultThemeConfig.logo_img}
            >
              <Routes>
                <Route
                  path=""
                  element={
                    <PrivateRoute roles={["admin"]} club={"uppers"}>
                      <VendorUser
                        themeConfig={themeConfig || defaultThemeConfig}
                      />
                    </PrivateRoute>
                  }
                />{" "}
              </Routes>
            </DashBoardLayout>
          }
        />
        <Route
          path=":id/benefits"
          element={
            <DashBoardLayout
              logo={themeConfig?.logo_img || defaultThemeConfig.logo_img}
            >
              <Routes>
                <Route
                  path=""
                  element={
                    <PrivateRoute>
                      {" "}
                      <VendorBenefits
                        themeConfig={themeConfig || defaultThemeConfig}
                      />
                    </PrivateRoute>
                  }
                />{" "}
              </Routes>
            </DashBoardLayout>
          }
        />
        <Route
          path=":id/benefits/:id"
          element={
            <DashBoardLayout
              logo={themeConfig?.logo_img || defaultThemeConfig.logo_img}
            >
              <Routes>
                <Route
                  path=""
                  element={
                    <PrivateRoute>
                      <Benefits
                        themeConfig={themeConfig || defaultThemeConfig}
                      />
                    </PrivateRoute>
                  }
                />{" "}
              </Routes>
            </DashBoardLayout>
          }
        />

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </ThemedApp>
  );
};

export default AppRoutes;
